import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Toolbar  from '@material-ui/core/Toolbar';
import MuiAppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';

import LogoButton from './components/LogoButton';
import FullsizeLogo from 'components/Logo/FullsizeLogo';
import AppMenu from './components/AppMenu';

const useStyles = makeStyles(theme => (
  {
    toolbar: theme.mixins.toolbar,
    logo: {
      marginRight: theme.spacing(1),
    },
    title: {
      flexGrow: 1,
    },
    appBar: {
      //background: theme.palette.background.paper,
      transition : theme.transitions.create(['background', 'color'], 
      { duration: theme.transitions.duration.standard })
    },
  }));

export default function AppBar(props) {
  const {
    title,
    buttons,
    disabled
  } = props;

  const classes = useStyles();

  if (disabled) return null;

  return(
    <React.Fragment>
      <MuiAppBar position="fixed" elevation={1} color="secondary" className={classes.appBar}>
        <Toolbar>
          {
            title ? <LogoButton edge="start" color="inherit" disabled /> :
                    <FullsizeLogo />
          }
          <Typography variant="h6" className={classes.title}>
            {props.title}
          </Typography>
          <AppMenu buttons={buttons} />
        </Toolbar>
      </MuiAppBar>
      <div className={classes.toolbar} />
    </React.Fragment>);
}